export default function Instructions() {
  const stepList: React.CSSProperties = { lineHeight: 1.9, paddingLeft: 22, margin: '8px 0 20px' };
  const card: React.CSSProperties = {
    background: 'var(--bg-card)',
    border: '1px solid var(--border)',
    borderRadius: 10,
    padding: '18px 22px',
    marginBottom: 18,
  };
  const h: React.CSSProperties = { margin: '0 0 6px' };
  const tip: React.CSSProperties = {
    background: 'var(--bg-subtle)',
    borderLeft: '3px solid var(--accent)',
    padding: '8px 12px',
    borderRadius: 6,
    margin: '10px 0 0',
    fontSize: 14,
    color: 'var(--text-muted)',
  };

  return (
    <div style={{ maxWidth: 760, lineHeight: 1.6 }}>
      <h2>Инструкция</h2>
      <p style={{ color: 'var(--text-muted)', marginTop: 0 }}>
        Пошаговое руководство. Жирным выделено то, что видно на экране — на это нужно нажимать.
      </p>

      <div style={card}>
        <h3 style={h}>📁 Загрузить файлы за период</h3>
        <ol style={stepList}>
          <li>Слева в меню нажмите <b>Загрузка</b>.</li>
          <li>Нажмите <b>+ Добавить кластер</b>.</li>
          <li>Введите название, например <code>dd 1quart 2026</code>, и нажмите <b>Создать</b>.</li>
          <li>В списке появится новый кластер — <b>нажмите на него</b>.</li>
          <li>Ниже появятся строки <b>7111, 7211, 7470, osv</b>. Напротив каждой нажмите кнопку выбора файла и выберите нужный Excel.</li>
          <li>Нажмите <b>Загрузить файлы</b>.</li>
          <li>Если напротив файла написано имя файла (а не «выбрать») — он загружен. ✅</li>
        </ol>
        <p style={tip}>
          💡 Если есть файлы ИП (sole_7211 / sole_7212) или «Отчёт о совокупном доходе» — раскройте раздел
          <b> Дополнительно</b> и загрузите их туда же.
        </p>
      </div>

      <div style={card}>
        <h3 style={h}>📊 Посмотреть отчёт</h3>
        <ol style={stepList}>
          <li>Слева нажмите <b>Главная</b>.</li>
          <li>Сверху выберите <b>Кластер</b> (предприятие/период) и <b>Конфиг</b> (вид отчёта).</li>
          <li>Появится таблица. Чтобы увидеть, из чего сложилась сумма — <b>нажмите на строку</b>, она раскроется.</li>
        </ol>
      </div>

      <div style={card}>
        <h3 style={h}>🧾 Сравнить с master (эталоном)</h3>
        <ol style={stepList}>
          <li>Слева нажмите <b>Сравнение</b>.</li>
          <li>Выберите <b>Кластер</b> и <b>Конфиг</b>.</li>
          <li>Смотрите три колонки: <b>Значение</b> (посчитал xelence), <b>Master</b> (эталон), <b>Δ</b> (разница).</li>
          <li>Если <b>Δ = 0</b> — всё сходится. Если нет — смотрите колонку <b>комментариев</b> справа.</li>
        </ol>
      </div>

      <div style={card}>
        <h3 style={h}>❓ Цифра не сходится (Δ не ноль)</h3>
        <p style={{ margin: '4px 0 8px' }}>Проверьте по порядку:</p>
        <ol style={stepList}>
          <li>Все ли файлы загружены? Зайдите в <b>Загрузка</b> → выберите кластер → проверьте список.</li>
          <li>Есть ли <b>комментарий</b> на этой строке (на странице Сравнение справа)? Обычно там уже написана причина.</li>
          <li>Если в комментарии «<b>расхождение источника</b>» — это разные цифры в файлах, программа тут ни при чём. Нужно сверить с бухгалтером.</li>
        </ol>
      </div>

      <div style={card}>
        <h3 style={h}>📈 Сводный отчёт (Overall)</h3>
        <ol style={stepList}>
          <li>Слева нажмите <b>Сводный</b> — все предприятия в одной таблице.</li>
          <li><b>Настроить колонки</b> — выбрать, какие кластеры показывать.</li>
          <li><b>⚙ Настройки</b> — указать <b>число месяцев</b> периода (например 3 для квартала). Влияет на ЗП АУП.</li>
        </ol>
      </div>

      <div style={card}>
        <h3 style={h}>🗂 Группы (по желанию)</h3>
        <ol style={stepList}>
          <li>Слева нажмите <b>Группы</b>.</li>
          <li>Нажмите <b>+ Add Group</b>, дайте название (например «1 квартал 2026»).</li>
          <li>Отметьте галочками кластеры, которые входят в группу.</li>
          <li>Теперь на странице <b>Загрузка</b> можно фильтровать кластеры по группе. На цифры это не влияет.</li>
        </ol>
      </div>
    </div>
  );
}
